import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Box } from '@lightspeed/flame/Core';
import { IconChevronDown } from '@lightspeed/flame/Icon/ChevronDown';
import kebabCase from 'lodash/kebabCase';

import { createReactRenderer } from 'helpers/react-renderer';
import { toBoolean } from 'pages/utils/sanitize';

interface Props {
  items: Item[];
}

type Item = { name: string; url: string };

const PrintDropDown: React.FC<Props> = (props) => {
  const handlePrintOptionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    const {
      target: { value },
    } = event;

    let getUrlFromProps = '';

    // eslint-disable-next-line array-callback-return
    props.items?.find((item) => {
      if (item.name === value) {
        getUrlFromProps = item.url;
      }
    });

    if (value.includes('labels')) {
      window.merchantos.print.handlePrintLabels({
        url: getUrlFromProps,
        target: '_blank',
        isZbpEnabled: toBoolean(window.merchantos.session.sessData?.Shop?.zebraBrowserPrint),
      });
    } else {
      window.merchantos.print.printUrl({
        url: getUrlFromProps,
        pageType: 'report',
        isHubPrintable: false,
      });
    }
  };

  return (
    <Box style={{ position: 'relative', float: 'left', height: '34px' }}>
      <Button>
        Print <IconChevronDown baseColor="#fff" />
      </Button>
      <select
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          background: 'transparent',
          color: 'transparent',
          outline: 'none',
          marginTop: '10px',
          height: '34px',
          border: 'none',
          cursor: 'pointer',
        }}
        onChange={(event) => handlePrintOptionChange(event)}
        value=""
        data-test="purchase-order-button"
      >
        <option hidden>Print</option>
        {props.items?.map((item: Item, index: any) => {
          return (
            <option
              id={`purchase-order-print-${kebabCase(item.name)}`}
              key={item.name}
              data-test={`purchase-order-dropdown-list${index}`}
              value={item.name}
              style={{ color: 'initial' }}
            >
              {item.name}
            </option>
          );
        })}
      </select>
    </Box>
  );
};

const RenderedComponent = createReactRenderer({
  component: PrintDropDown,
  selector: '[data-react-root="PrintDropDown"]',
});

export default PrintDropDown;

history.onChangeState(
  [
    {
      name: ['purchase.views.purchase'],
      form_name: 'view',
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
